export const SET_ANALYTICS_DATA = 'SET_ANALYTICS_DATA'
export const SET_MAP_BOUNDS = 'SET_MAP_BOUNDS'
export const CHANGE_FILTER_TYPE = 'CHANGE_FILTER_TYPE'
export const CHANGE_SELECTED_DATE = 'CHANGE_SELECTED_DATE'

export const setAnalyticsData = payload => dispatch =>
  dispatch({
    type: SET_ANALYTICS_DATA,
    payload: payload
  })
export const setMapBounds = payload => dispatch =>
  dispatch({
    type: SET_MAP_BOUNDS,
    payload: payload
  })

export const changeFilterType = payload => dispatch =>
  dispatch({
    type: CHANGE_FILTER_TYPE,
    payload
  })
export const changeSelectedRange = payload => dispatch =>
  dispatch({
    type: CHANGE_SELECTED_DATE,
    payload
  })
